// extracted by mini-css-extract-plugin
export default {"tab":"TabStructure_tab__beTsE","active":"TabStructure_active__J-xan","tabControlBtn":"TabStructure_tabControlBtn__3LxAM","flyin":"TabStructure_flyin__3B0w2"};